import type { Stage } from '~/lib/types'

/*
  Pipeline stages ride a single-hue ramp so the order reads as progress;
  terminal outcomes use the status palette. Every badge carries its label, so
  the color is reinforcement, never the only signal.
*/
const STAGES: Record<Stage, { label: string; dot: string }> = {
  not_initiated: { label: 'Not initiated', dot: 'bg-faint' },
  initiated: { label: 'Initiated', dot: 'bg-stage-1' },
  engaged: { label: 'Engaged', dot: 'bg-stage-2' },
  interested: { label: 'Interested', dot: 'bg-stage-3' },
  converted: { label: 'Converted', dot: 'bg-good' },
  lost: { label: 'Lost', dot: 'bg-critical' },
}

export default function StageBadge({ stage }: { stage: Stage }) {
  const meta = STAGES[stage]

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-line px-2.5 py-0.5 text-xs whitespace-nowrap">
      <span aria-hidden="true" className={`size-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  )
}

export const STAGE_LABELS = Object.fromEntries(
  Object.entries(STAGES).map(([key, meta]) => [key, meta.label]),
) as Record<Stage, string>
